import React, { useState, useEffect } from 'react';
import { getDatabase, ref as dbRef, onValue, push, remove, set } from 'firebase/database';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import Masonry from 'react-masonry-css';
import './DigitalMoods.css';

const DigitalMoods = ({ userId }) => {
    const [moods, setMoods] = useState([]);
    const [newMood, setNewMood] = useState({ file: null, description: '' });
    const [preview, setPreview] = useState(null);
    const [addingMood, setAddingMood] = useState(false);

    const database = getDatabase();
    const storage = getStorage();

    useEffect(() => {
        if (!userId) return;

        const moodsRef = dbRef(database, `Brandbooks/${userId}/moods`);
        onValue(moodsRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                setMoods(Object.entries(data).map(([key, value]) => ({ id: key, ...value })).reverse());
            } else {
                setMoods([]);
            }
        });
    }, [userId, database]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setNewMood({ ...newMood, file });

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            setPreview(null);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewMood({ ...newMood, [name]: value });
    };

    const addMood = () => {
        if (!newMood.file) return;

        const fileRef = storageRef(storage, `moods/${userId}/${newMood.file.name}`);
        uploadBytes(fileRef, newMood.file).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((downloadURL) => {
                const moodsRef = dbRef(database, `Brandbooks/${userId}/moods`);
                const newMoodRef = push(moodsRef);
                set(newMoodRef, { file: downloadURL, description: newMood.description });
                setNewMood({ file: null, description: '' });
                setPreview(null);
                setAddingMood(false);
            });
        });
    };

    const deleteMood = (moodId) => {
        const moodRef = dbRef(database, `Brandbooks/${userId}/moods/${moodId}`);
        remove(moodRef);
    };

    const downloadMood = (url) => {
        const link = document.createElement('a');
        link.href = url;
        link.download = url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const breakpointColumnsObj = {
        default: 2,
        1300: 1
    };

    return (
        <div className="digital-moods">
            <h2>Moods</h2>
            {addingMood ? (
                <div className="add-mood">
                    <h3>Add Mood</h3>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="file-input"
                        id="mood-file-upload"
                    />
                    <label htmlFor="mood-file-upload" className="file-input-label">
                        Choose File
                    </label>
                    {preview && <img src={preview} alt="Preview" className="mood-preview" />}
                    <input
                        type="text"
                        name="description"
                        value={newMood.description}
                        onChange={handleInputChange}
                        placeholder="Description"
                    />
                    <button onClick={addMood}>Add Mood</button>
                </div>
            ) : (
                <div className="add-color-nema" style={{ display: 'flex' }} onClick={() => setAddingMood(true)}>
                    <img className="moods-plus-icon" src="./img/plus.svg" alt="Plus Icon" />
                    <span>Click here to Add Mood</span>
                </div>
            )}
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="moods-container"
                columnClassName="moods-column"
            >
                {moods.map((mood) => (
                    <div key={mood.id} className="mood-item">
                        <img src={mood.file} alt={mood.description} className="mood-image" />
                        <p>{mood.description}</p>
                        <div onClick={() => deleteMood(mood.id)} className="moods-delete-icon">
                            <img src='./img/trasher.svg' alt="Delete" style={{ top: '20px', right: '15px', filter: 'invert(1)' }} className="branding-delete-button" />
                        </div>
                        <div onClick={() => downloadMood(mood.file)} className="moods-download-icon">
                            <img src='./img/downloads.svg' alt="Download" className="branding-download-button" />
                        </div>
                    </div>
                ))}
            </Masonry>
        </div>
    );
};

export default DigitalMoods;
